module.exports = __webpack_public_path__ + "img/dancing_logo.3b1dc970.png";